import React, { Component } from 'react';

const propTypes = {};

const defaultProps = {};

class ContactPipedrive extends Component {

    render() {
        return (
            <div
                className="pipedriveWebForms"
                data-pd-webforms="https://webforms.pipedrive.com/f/nOe631Fs3gpMaIeELSjSmWsdzAIJSBebJjhO8cZgtbwNFID4OKQGmngS9kLgSe7"
            >
                <embed
                    src="https://webforms.pipedrive.com/f/nOe631Fs3gpMaIeELSjSmWsdzAIJSBebJjhO8cZgtbwNFID4OKQGmngS9kLgSe7"
                    style={{
                        width: '100%',
                        height: '100%',
                        minHeight: '970px',
                    }}
                />
            </div>
        );
    }

}

ContactPipedrive.propTypes = propTypes;

ContactPipedrive.defaultProps = defaultProps;

export default ContactPipedrive;
